<template>
  <v-col cols="12">
    <Loader
      v-if="loading"
      :key="generateUniqueId()"
      :loader-state="loading"
    ></Loader>

    <v-card>
      <v-card-title>Metadonnées</v-card-title>

      <v-card-text>
        <div class="global-actions">
          <router-link :to="{ name: 'metadataCreate' }">
            <v-btn
              small
              color="primary"
              class="mt-5"
            >
              Ajouter des métadonnées
            </v-btn>
          </router-link>
        </div>
      </v-card-text>

      <div class="clear"></div>

      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-uppercase">
                Page
              </th>
              <th class="text-center text-uppercase">
                Titre
              </th>
              <th class="text-center text-uppercase">
                Description
              </th>
              <th class="text-center text-uppercase">
                Mots-clés
              </th>
              <th class="text-center text-uppercase">
                Actions
              </th>
            </tr>
          </thead>
          <tbody v-if="metadata.length">
            <tr
              v-for="(data, dataIndex) in metadata"
              :key="'d' + dataIndex"
            >
              <td class="font-weight-bold">
                {{ data.page ? data.page : '-' }}
              </td>
              <td class="text-center">
                {{ resolveAttrValue(data, 'title') }}
              </td>
              <td class="text-center">
                {{ resolveAttrValue(data, 'description') }}
              </td>
              <td class="text-center">
                {{ resolveAttrValue(data, 'keywords') }}
              </td>
              <td class="text-center">
                <v-tooltip top>
                  <template #activator="{ on, attrs }">
                    <v-btn
                      color="warning"
                      fab
                      dark
                      x-small
                      v-bind="attrs"
                      :to="{ name: 'metadataDetails', params: { metadataId: data.id }}"
                    >
                      <v-icon dark>
                        {{ icons.mdiEye }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Consulter</span>
                </v-tooltip>

                <v-tooltip top>
                  <template #activator="{ on, attrs }">
                    <v-btn
                      class="ml-2"
                      color="error"
                      fab
                      dark
                      x-small
                      v-bind="attrs"
                      @click="openDeleteMetadataDialog(data)"
                    >
                      <v-icon dark>
                        {{ icons.mdiTrashCan }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Supprimer</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
          <tbody v-if="!metadata.length">
            <tr>
              <td>
                <span v-if="loading === false">Aucun éléments.</span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <DeleteMetadataDialog
        :key="Date.now()"
        :delete-metadata-dialog-state="deleteMetadataDialogState"
        :metadata="metadataToDelete"
        @closeDeleteMetadataDialog="closeDeleteMetadataDialog($event)"
      ></DeleteMetadataDialog>
    </v-card>
  </v-col>
</template>

<script>
import { mdiPlay, mdiPen, mdiEye, mdiTrashCan } from '@mdi/js'
import Vue from 'vue'
import DeleteMetadataDialog from '@/components/Dialog/SeoDialog/Metadata/DeleteMetadataDialog'
import config from '../../../config'
import Loader from '@/components/Common/Loader'

export default {
  components: {
    DeleteMetadataDialog,
    Loader
  },
  data: () => ({
    metadata: [],
    metadataToDelete: null,
    deleteMetadataDialogState: false,
    loading: false,
    icons: {
      mdiPlay,
      mdiPen,
      mdiEye,
      mdiTrashCan
    }
  }),
  created () {
    this.getMetadata()
  },
  methods: {
    getMetadata () {
      this.loading = true

      Vue.prototype.$http
        .get(config.apiUrl + '/api/seo/metadata', {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.getToken
          }
        })
        .then(response => {
          if (response.status === 200) {
            const data = response.data

            if (data) {
              this.metadata = data
            }
          }

          this.loading = false
        })
        .catch(e => {
          const response = e.response

          if (response.status === 400 || response.status === 404) {
            const data = response.data
            this.errors = data.violations
          }

          this.valid = true
          this.loading = false
        })
    },
    openDeleteMetadataDialog (metadata) {
      this.deleteMetadataDialogState = true
      this.metadataToDelete = metadata
    },
    closeDeleteMetadataDialog (deleteState) {
      if (deleteState === true) {
        this.metadata = this.metadata.filter(element => element.id !== this.metadataToDelete.id)
      }

      this.deleteMetadataDialogState = false
    },
    resolveAttrValue (data, attr) {
      const translations = data.translations

      if (translations.fr) {
        return translations.fr[attr]
      }

      return '-'
    }
  }
}
</script>
